import React from 'react';
import PropTypes from 'prop-types';
import GiftCardPromoElement from './components/GiftCardPromoElement';
import GiftCardSearchElement from './components/GiftCardSearchElement';
import GiftCardListing from './components/GiftCardListing';
import useGiftCardListing from './hooks/useGiftCardListing';

const GiftCardListingPage = ({
  itemId,
  managedContentEndpoint,
  listingEndpoint,
  termsAndConditionsCtaLabel,
  termsAndConditionsCtaLink,
  purchaseCtaLabel,
  noResultsMessage,
  ...searchElementProps
}) => {
  const {
    setSearchQuery,
    searchQuery,
    goal,
    giftCards,
    facets,
    managedContentRequest,
    refetchGiftCards,
    handleFacetChange,
    handleFacetClear,
    loadingGiftCards,
    giftCardListingElement,
    errorGiftCards,
    initialized,
    searchHappened
  } = useGiftCardListing({ listingEndpoint, managedContentEndpoint, itemId });

  return (
    <section className="">
      <GiftCardSearchElement
        {...searchElementProps}
        {...{
          searchQuery,
          setSearchQuery,
          handleFacetChange,
          handleFacetClear,
          facets
        }}
        handleFormSubmit={refetchGiftCards}
        links={
          managedContentRequest.data
            ? managedContentRequest.data.headerLinks
            : []
        }
      />
      {console.log(managedContentRequest.data)}
      {!searchHappened &&
        !managedContentRequest.error &&
        !managedContentRequest.loading &&
        managedContentRequest.data &&
        managedContentRequest.data.promoElement &&
        managedContentRequest.data.promoElement.title &&
        managedContentRequest.data.promoElement.copy &&
        managedContentRequest.data.promoElement.backgroundImage && (
          <GiftCardPromoElement {...managedContentRequest.data.promoElement} />
        )}
      <GiftCardListing
        ref={giftCardListingElement}
        {...{
          termsAndConditionsCtaLink,
          termsAndConditionsCtaLabel,
          purchaseCtaLabel,
          loadingGiftCards,
          initialized,
          noResultsMessage
        }}
        listing={giftCards}
        goal={goal}
        error={errorGiftCards}
      />
    </section>
  );
};

GiftCardListingPage.propTypes = {
  itemId: PropTypes.string.isRequired,
  managedContentEndpoint: PropTypes.string.isRequired,
  listingEndpoint: PropTypes.string.isRequired,
  headerTitle: PropTypes.string.isRequired,
  headerCopy: PropTypes.string.isRequired,
  searchInputLabel: PropTypes.string.isRequired,
  searchInputPlaceholder: PropTypes.string.isRequired,
  filtersLabel: PropTypes.string.isRequired,
  linksTitle: PropTypes.string.isRequired,
  termsAndConditionsCtaLink: PropTypes.string.isRequired,
  termsAndConditionsCtaLabel: PropTypes.string.isRequired,
  purchaseCtaLabel: PropTypes.string.isRequired,
  noResultsMessage: PropTypes.string.isRequired
};

export default GiftCardListingPage;
